<template>
  <div>
    <b-modal
      id="modal-default-info"
      ref="modalInfoWithTimeOut"
      centered
      :hide-header="!dataModal.title"
      hide-footer
      @hidden="hidden()"
    >
      <template v-slot:modal-title v-if="dataModal.title">
        {{ dataModal.title }}
      </template>
      <div class="d-block text-center mb-3" v-if="dataModal.img">
        <img :src="dataModal.img" alt="" />
      </div>
      <div class="d-block text-center">
        <p v-html="dataModal.text" />
      </div>
      <div v-if="dataModal.buttons" class="row m-0 mt-4 justify-content-center">
        <button
          v-for="(btn, idx) in dataModal.buttons"
          :key="idx"
          :class="btn.class"
          @click="actionButton(btn.action, btn.isLoading)"
        >
          <span v-if="btn.isLoading" class="spinner__small--white">
            <b-spinner></b-spinner>
          </span>
          <span v-else>{{ btn.text }}</span>
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ModalInfoTImeOut',
  props: {
    openModal: Boolean,
    isLoading: Boolean,
    dataModal: Object
  },
  watch: {
    isLoading(data) {
      if (data && data === false) {
        this.$refs.modalInfoWithTimeOut.hide()
      }
    },
    openModal(data) {
      if (data == true) {
        this.$refs.modalInfoWithTimeOut.show()
        setTimeout(() => {
          this.$emit('update:openModal', false)
          this.$refs.modalInfoWithTimeOut.hide()
        }, 3000)
      }
    }
  },
  methods: {
    actionButton(type, action) {
      this.$emit(type, action)
      this.$refs.modalConfirmCustoms.hide()
    },
    hidden() {
      this.$emit('update:openModal', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/modals/ModalInfo.vue